import { Cookies } from 'react-cookie';

import { HeatMapSBSDataResponse } from './types';

import axiosInterceptor from 'api/interceptor/axiosClient';

export const getHeatMapSBSData = async (planSlug: string, dateStart: string, dateEnd: string) => {
  const cookies = new Cookies();
  const token = cookies.get('local_access_token');
  const data = await axiosInterceptor.get(`api/v1/floorplans/${planSlug}/signals`, {
    headers: {
      Authorization: token,
    },
    params: {
      date_start: dateStart,
      date_end: dateEnd,
    },
  });

  return data.data as HeatMapSBSDataResponse;
};
